module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The lesser stars had faded, but the brightest soldiered on. As a new day approached, the dark eye of the Dream God had set in the southwest; a distant rooster had already begun summoning his wives. Soon the great city of Casr would waken.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Something had wakened Wallie. Something wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was something very sharp underneath him, digging into his back. The long summer heat still lingered, so he and Jja slept on the balcony outside their bedroom, overlooked by no one. The pallet they lay on was thin, because that let the floor tiles keep them cool on hot nights. No, there was more disturbing him than whatever the sharp thing was. The waist-high parapet around the balcony was armored with downward-pointing spikes on the outside, supposedly making it inaccessible to intruders. Glancing around through half-closed lids and making no unnecessary move, Wallie detected a watcher studying him over the edge: an assassin, on his way in, three floors above the courtyard. His face was blacker than the night behind him. Only the gleam of his eyes gave him away—that, and white teeth holding a knife. Already he was clambering over the parapet, being careful not to catch his legs on the spikes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Asleep or awake, a swordsman should never be far from his sword, especially if that swordsman happened to be vice-emperor of the World. There had been at least a dozen assassination attempts against Nnanji since the founding of the Tryst, and three or four against Wallie, although none for several years. His sword lay beside the pallet, true, but it was a king-sized pallet, and he was closer to Jja’s side of it than his own. He would have to lunge to reach it, presenting his back to the killer. He was also under the bed sheet. If Jja had her side of the sheet wrapped around her, he would become entangled. The attacker would be inside his guard before he could find the sword hilt and sit up to meet the attack. An assassin skilled enough to climb the wall might well be skilled enough to throw his knife.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie must be growing careless in his old age.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He did not intend to stop growing older yet, though.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had a few advantages. He was awake, which the intruder could not know yet, and he had Shonsu’s great size and strength. The long-dead Wallie Smith, a somewhat sedentary chemical engineer on another world, would have had very little chance in this situation, although assassination had not been an occupational hazard for him back then. His right arm was under the sheet, the left one outside, but Shonsu was ambidextrous, and the killer would have to approach from his left, to avoid wakening Jja.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The intruder swung his feet down to the balcony without a sound. At once he dropped low, so he was no longer silhouetted against the sky. He was good! He was now waiting to learn if he had been detected. Wallie kept his breathing slow, despite his racing heart. The killer began creeping closer, although Wallie had no idea how he knew that, for the man seemed to make no noise at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then the killer’s foot nudged the sword, which made a very faint scraping noise on the stonework, so he was already within striking distance, and Wallie had not expected that. He sat up with a howl and swung his pillow to deflect the knife coming at him. Except it wasn’t a knife, it was his own sword, and that misjudgment very nearly decided the contest right then there. He deflected the stroke just enough that he could throw himself flat, underneath it, and grab the intruder’s ankle. Before his hand could be sliced off, he yanked as hard as he could. The man went down.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Judging by his size, he could hardly be more than a boy, but he was "), _c('i', [_vm._v("very ")]), _vm._v("good, as lithe as a snake, up on his feet as soon as Wallie was. For a moment they faced off, both crouching slightly, a pillow against a sword and a knife. The killer was wielding the sword with his left hand, so he might well be ambidextrous also. This time the assassin lunged, instead of slashing. The blade went right through the pillow, and Wallie only narrowly escaped being impaled. But he caught his opponent’s right wrist and heaved him around, clean off his feet, hoping to slam him against the wall. He had forgotten the ornamental granite column that stood there, supporting a large brass pot. The pot made a resounding clang as it hit the tiles, while the impact of the column was probably felt throughout the building.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That hadn’t worked, so Wallie heaved him around in the opposite direction, despite the risk of dropping him on Jja, who was making protesting noises. Again the youth displayed superhuman agility, landing on his feet and yanking the sword free of the pillow in a blizzard of feathers. He might have won the battle at that moment by slashing Wallie’s hamstring or Achilles tendon, but Jja sank her teeth in his calf, and that threw his timing off.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie got him by the throat, hauled his arm around his back, and deliberately dislocated his shoulder. The boy screamed and dropped both weapons. Just to make sure, Wallie threw him flat, face down, and knelt on him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You all right, darling?” he inquired in the calmest voice he could summon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just a nasty taste in my mouth. You?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perfectly well, thank you. I appreciate the judicious assistance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At that moment Vixini burst in like an avenging angel. Even before the door at the far end of the bedroom hit the wall, he was out on the balcony, standing over them with his sword in one hand and a flaming torch in the other. He roared, "), _c('i', [_vm._v("“What?”… ")]), _vm._v("and stopped with a gulp when he realized that both his parents were stark naked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re supposed to knock first,” Wallie said. “Especially when we have visitors.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("“What is going on?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We were entertaining an assassin, until your mother tried to chew his leg off.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("By that time Jja had managed to free enough of the sheet to pull it up to her chin. “Fetch my robe, will you, Son?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As Vixini turned to obey, four more swordsmen ran in, led by Adept Sevolno, head of Lord Shonsu’s night watch. He showed his teeth in fury at the sight of the intruder—fury mixed with fear, perhaps. When Lord Nnanji heard about this, he might have Sevolno’s sword for it, and possibly his head as well. Nnanji was due back in Casr before noon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Take him,” Wallie said, rising. “Careful of his arm. No, don’t maltreat him!” he shouted, as two of the others grabbed the assassin. “Oh, Goddess! "), _c('i', [_vm._v("Her ")]), _vm._v("arm, I mean.” Displayed in the light of the torches, the captive was both naked and undoubtedly female. “Bring her in here. I want to talk with her.” He led the way into the bedroom, leaving Jja with some privacy. The five swordsmen followed, Vixini with his sword still unsheathed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie grabbed up his kilt from where he had thrown it on the bed and made himself respectable. Then he pulled a sheet from the bed and draped it around the woman, telling the swordsmen to guard the door so she couldn’t make a run for it; also the archway to the balcony so she couldn’t jump to her death.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then he took a good look at her. She was young, as was to be expected, and petite, with the elfin figure of a gymnast. She wore her hair short, as did everyone except swordsmen. The People varied in color from light to dark brown, but he had never seen any as dark as she. She had been dyed. Peering closely at her forehead he saw no visible craft marks, which the laws of the Goddess required on every adult, although she was no longer a child. Removing facemarks was an old sorcerer trick, although even hiding them under a coat of dye would be a felony.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Let me see your eyelids,” he said. She just stared up at him in resentful silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He smacked her nose—not so hard that it would bleed, but hard enough to make her blink. As far as he could tell from that brief glimpse of her eyelids, she bore no parent marks either, and the skin there, where the dye had worn off, was much paler.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You’re a sorcerer,” he said firmly. Only sorcerers could make tattoos disappear, although even the sorcerers officially never did it now, since the Treaty of Casr had brought them into the mainstream of the People’s culture. Facemarks were basic to the society of the World.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The prisoner did not speak. Instead she opened her mouth wide, making Wallie recoil in horror. Where her tongue should be was a stump of white scar tissue. She leered at him triumphantly. What sort of fanatic would let her tongue be cut out to prevent her from revealing secrets? Or had she been bribed with a lie that sorcerers could replace missing organs by magic?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, you can still be questioned,” he said. “You can write your answers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shook her head vigorously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He smiled. She grimaced as she realized that he had trapped her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vixini missed that exchange and put the idea into words. “We can make her talk, my lord! We can play twenty-one questions with her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maybe,” Wallie said. “Prisoner, I will promise you your life if you will answer a few questions for me now by nodding or shaking your head. Are you a sorcerer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Were you sent by a sorcerer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Still none. He did not care much who she was, but he very much wanted to know who had hired her. Most attempts on his life or Nnanji’s had been made by dissident swordsmen wanting to return to the old ways of independent city garrisons and roaming bands of free swords. A few had been organized by corrupt rulers or gang leaders who opposed the law and order that the Tryst was seeking to impose on the World. Even religious fanatics had tried, although they had never come this close to success.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Obviously this assassin was not going to cooperate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We have the rest of your life to question you,” he said. “Adept Sevolno?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My lord.” The swordsman pulled out his sword and knelt to offer it to Wallie, head bowed in shame.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Get up, you fool. I want to know how this she-cat got into the grounds and up the wall and past the spikes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We’ll make her show us,” Sevolno said with a menacing smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not that way! Keep her well locked up, certainly, but find decent clothes for her and call a healer to treat her shoulder. He may give her a potion to ease the pain. You can ask her questions, but no rough stuff, understand?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("One of the first reforms Wallie had imposed on the People had been a complete ban on torture, on the grounds that the information it produced was useless. Sevolno certainly knew that, but a swordsman, and especially one feeling that he had failed in his duty, could easily become overzealous.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So I want you to go and "), _c('i', [_vm._v("look")]), _vm._v(", to find out how she got in. And if you’ve gone off duty…” Wallie glanced thoughtfully at young Vixi. He was not a member of the palace night watch and normally wild oxen were needed to get him out of bed in the morning. How had he managed to respond to the disturbance sooner than anyone else? One would get you ten that he had just come home and hadn’t been to bed yet. Not his own bed, anyway. He might have taken up wenching, certainly, but more likely he had just been carousing with other low-ranks. “Take Apprentice Vixini around with you and show him what you find. If you’ve gone off duty before I come down, he can pass on your report. Meanwhile, I’m going to finish my night’s sleep. Dismissed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie strode out to the balcony again, chuckling in silence at the dismayed expression he had seen come over his stepson’s face. As one of Wallie’s protégés, Vixi must stay in constant attendance on his mentor, and Nnanji’s return was certain to keep Wallie on the run every minute until, very likely, past midnight. By then Apprentice Vixini would be regretting his late night.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Jja was under the covers again, but wide-awake. She watched as he retrieved his sword and laid it beside the bed. He dropped his kilt and lay down beside her. The sky was the indefinable, colorless shade it turns just before sunrise.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s not worth going to sleep again,” she said. She was a big, powerful woman, who had borne four children already and showed no signs of wanting to stop. An invitation like that saved him from making the suggestion. He slid an arm under her and cuddled close. "), _c('i', [_vm._v("Ouch!")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Annoyed at the distraction, he felt around and located the sharp object that had wakened him when he had rolled on it earlier, a jagged pebble. He held it up between finger and thumb and whistled in astonishment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What’s that?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This, my darling, is what saved my life, and probably yours too. It woke me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But where did it come from?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That question had no rational answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t ask ‘where’, ask ‘who’.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, ‘who’. Our little friend, remember? You met him once.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie had met him four times. Each time he had appeared as a small, undernourished boy with a gap in his teeth and a big smile, but he was a demigod, a messenger from the maternal deity of the World, known simply as ‘the Goddess’. When Wallie had invented the treaty to end the age-old feud between the swordsmen and the sorcerers, the demigod had promised no more miracles. In his own right the demigod was god of jewels, though, and if the appearance of an uncut diamond as big as a thumb joint in a man’s bed was not a miracle, then what was it? And if it was, did that mean that events had taken a turn that not even the gods had foreseen?")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c03c972","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section6.vue
// module id = 81
// module chunks = 0